import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Menu
 */
export default class Menu extends withBreakpointObserver(Base) {
  /**
   * App config.
   * @returns {Object}
   */
  static config = {
    name: 'MenuMobile',
    refs: ['burger', 'burgerClose', 'burgerOpen', 'navHolder', 'navBackground'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m l',
      },
    },
  };

  isClosed = true;

  /**
   * Mounted.
   *
   * @returns {void}
   */
  mounted() {
    this.close();
  }

  /**
   * onBurgerClick.
   *
   * @returns {void}
   */
  onBurgerClick() {
    if (this.isClosed) {
      this.open();
    } else {
      this.close();
    }
  }

  /**
   * Open the menu.
   *
   * @returns {void}
   */
  open() {
    this.$refs.burgerClose.classList.remove('hidden');
    this.$refs.burgerClose.classList.add('block');
    this.$refs.burgerOpen.classList.add('hidden');
    this.$refs.navHolder.classList.remove('-translate-x-full');
    this.$refs.navBackground.classList.add('has-background');
    document.body.classList.add('has-menu-open');
    document.body.classList.add('overflow-y-hidden');
    this.isClosed = false;
  }

  /**
   * Close the menu.
   *
   * @returns {void}
   */
  close() {
    this.$refs.burgerClose.classList.add('hidden');
    this.$refs.burgerClose.classList.remove('block');
    this.$refs.burgerOpen.classList.remove('hidden');
    this.$refs.navHolder.classList.add('-translate-x-full');
    this.$refs.navBackground.classList.remove('has-background');
    document.body.classList.remove('has-menu-open');
    document.body.classList.remove('overflow-y-hidden');
    this.isClosed = true;
  }

  /**
   * Destroyed.
   *
   * @returns {void}
   */
  destroyed() {
    document.body.classList.remove('overflow-y-hidden');
  }
}
